import { Skeleton } from 'antd';
import ThemeProvider from '@/components/ThemeProvider';

const Loading: React.FC = () => {
  return (
    <ThemeProvider>
      <div style={{ padding: '24px 40px', height: '60vh' }}>
        <Skeleton active />
      </div>
    </ThemeProvider>
  );
};

export default Loading;
